// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { createTruck, deleteTruck, getDetailTruck, getListTruck, updateTruck } from './truckThunk';

export interface ITruckState {
  isRefreshTruckList: boolean;
}

export const initialState: ITruckState = {
  isRefreshTruckList: false,
};

const truckSlice = createSlice({
  name: 'truck',
  initialState,
  reducers: {
    setRefreshTruckList(state, action) {
      state.isRefreshTruckList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list truck
    builder
      .addCase(getListTruck.pending, (_state) => {})
      .addCase(getListTruck.fulfilled, (_state) => {})
      .addCase(getListTruck.rejected, (_state) => {});

    // GET: Get detail truck
    builder
      .addCase(getDetailTruck.pending, (_state) => {})
      .addCase(getDetailTruck.fulfilled, (_state) => {})
      .addCase(getDetailTruck.rejected, (_state) => {});

    // POST: Create truck
    builder
      .addCase(createTruck.pending, (_state) => {})
      .addCase(createTruck.fulfilled, (state) => {
        state.isRefreshTruckList = true;
      })
      .addCase(createTruck.rejected, (_state) => {});

    // PUT: Update  truck
    builder
      .addCase(updateTruck.pending, (_state) => {})
      .addCase(updateTruck.fulfilled, (state) => {
        state.isRefreshTruckList = true;
      })
      .addCase(updateTruck.rejected, (_state) => {});

    // DELETE: Delete truck
    builder
      .addCase(deleteTruck.pending, (_state) => {})
      .addCase(deleteTruck.fulfilled, (state) => {
        state.isRefreshTruckList = true;
      })
      .addCase(deleteTruck.rejected, (_state) => {});
  },
});

// Action
export const truckActions = truckSlice.actions;

// Selectors
// Reducer
const truckReducer = truckSlice.reducer;
export default truckReducer;
